module.exports = __webpack_public_path__ + "media/surface_mount_carriers/pressure-holder-flexible-c1796e26.png";